let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g5aO0")).then(() => parcelRequire('6Ue2s'));